"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var CustomPropTypes = _interopRequireWildcard(require("../../../../constants/PropTypes"));

var _immutable = _interopRequireDefault(require("immutable"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _NestedNav = _interopRequireDefault(require("ecosystem-marketplace-core/components/nav/NestedNav"));

var _NestedNavItem = _interopRequireDefault(require("ecosystem-marketplace-core/components/nav/NestedNavItem"));

var FilterKey = _interopRequireWildcard(require("../../../../constants/search/FilterKey"));

var _storefrontCollectionOrder = _interopRequireDefault(require("../../../../constants/storefrontCollectionOrder"));

var _history = require("../../../../utils/history");

var _i18n = require("../../../../utils/i18n");

var _urls = require("../../../../utils/urls");

var ALL = 'all';

var collectionsOrder = _immutable.default.OrderedSet([ALL].concat((0, _toConsumableArray2.default)(_storefrontCollectionOrder.default)));

var getCollectionPathname = function getCollectionPathname(collection) {
  switch (collection) {
    case ALL:
      return '/';

    default:
      return (0, _urls.getCollectionUrl)(collection);
  }
};

var CollectionsNav = function CollectionsNav(_ref) {
  var activeCollection = _ref.activeCollection,
      isAllCollections = _ref.isAllCollections,
      onCollectionChange = _ref.onCollectionChange,
      trackFilterNavItemClick = _ref.trackFilterNavItemClick;
  return _react.default.createElement(_NestedNav.default, {
    className: "m-bottom-0"
  }, collectionsOrder.map(function (collection) {
    return _react.default.createElement(_NestedNavItem.default, {
      key: collection,
      active: collection === ALL ? isAllCollections : collection === activeCollection,
      href: (0, _history.getFullHref)(getCollectionPathname(collection)),
      onClick: function onClick(evt) {
        evt.preventDefault();
        onCollectionChange(collection === ALL ? undefined : collection);
        trackFilterNavItemClick(FilterKey.COLLECTION, collection === ALL ? 'all collections' : collection);
      },
      title: (0, _unescapedText.default)((0, _i18n.getCollectionI18nKey)(collection))
    });
  }));
};

CollectionsNav.propTypes = {
  activeCollection: CustomPropTypes.storefrontCollection,
  isAllCollections: _propTypes.default.bool.isRequired,
  onCollectionChange: _propTypes.default.func.isRequired,
  trackFilterNavItemClick: _propTypes.default.func.isRequired
};
var _default = CollectionsNav;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/sidebar/nav/CollectionsNav.js
// module id = 712
// module chunks = 209 210 211 212